module.exports = __webpack_public_path__ + "img/export.efd92d34.svg";